import React, { useEffect, useState } from "react";
import { ChevronRight } from "lucide-react";
import api from "../../lib/api";
import { LEVEL_WORDS, ORIENTATIVE } from "../../lib/initialAssessmentAdmin";
import Answers from "../assessment/Answers";

/**
 * The participant's initial assessment, on their sheet in the trainer's
 * portal (15.10.2026): the orientative level and the answers, folded. Nothing
 * for a Curs FPED group, nor for one that did it outside the platform.
 */
export default function ParticipantAssessment({ groupId, enrollmentId }) {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get(`/portal/groups/${groupId}/participants/${enrollmentId}/initial-assessment`)
      .then((r) => setData(r.data)).catch(() => setData(null));
  }, [groupId, enrollmentId]);

  if (!data?.applies || data.external) return null;
  if (!data.completed) {
    return (
      <p className="mt-4 text-sm text-[#6B7280]" data-testid="portal-participant-assessment">
        Nivel inițial (orientativ): <span className="text-[#9CA3AF]">Necompletat</span>
      </p>
    );
  }
  return (
    <details className="group mt-6 rounded-2xl border border-[#E5E7EB] bg-white" data-testid="portal-participant-assessment">
      <summary className="flex cursor-pointer list-none items-center gap-3 px-4 py-3 [&::-webkit-details-marker]:hidden">
        <ChevronRight size={16} className="shrink-0 text-[#9CA3AF] transition-transform group-open:rotate-90" />
        <span className="min-w-0 flex-1">
          <span className="block text-sm font-semibold text-[#373A45]">
            Evaluarea inițială · {LEVEL_WORDS[data.score?.level] || "—"} <span className="font-normal italic text-[#6B7280]">(orientativ)</span>
          </span>
          <span className="block text-xs text-[#6B7280]">
            {data.after_start ? "Completată după începerea cursului · " : ""}Răspunsurile cursantului
          </span>
        </span>
      </summary>
      <div className="border-t border-[#E5E7EB] p-4">
        <p className="text-xs text-[#6B7280]">{ORIENTATIVE}</p>
        <Answers questionnaire={data.questionnaire} answers={data.answers} />
      </div>
    </details>
  );
}
